<template>
  <div class="ganme">
    <div class="content">
      <div class="top-line">
        <img src="../../assets/images/ganme/logo.svg" class="icon">
        <div class="search">
          <img src="../../assets/images/search.png" class="search" @click="searchInfo">
          <input
            v-model="searchHash"
            class="search"
            placeholder="宣言 / 协议哈希值"
            v-on:keyup.enter="searchInfo"
          >
        </div>
      </div>
      <div v-if="isValid">
        <div class="form-centent">
          <p class="title-line">区块信息</p>
          <div class="block-form">
            <ul>
              <li>
                <span>区块高度</span>
                <span>{{form.height}}</span>
              </li>
              <li>
                <span>宣言哈希</span>
                <span>{{[form.hash,size]|filterHash}}</span>
                <img
                  src="../../assets/images/ganme/copy.svg"
                  class="copy"
                  v-clipboard:copy="form.hash"
                  v-clipboard:success="success"
                  v-clipboard:error="error"
                >
              </li>
              <li>
                <span>上链时间</span>
                <span>{{form.blockTime|fulltime}}</span>
              </li>
            </ul>
          </div>
          <p class="title-line">用户信息</p>
          <div>
            <ul>
              <li>
                <span>发起人</span>
                <span>{{userInfo.originatorNickName}}</span>
              </li>
              <li>
                <span>接收人</span>
                <span>{{userInfo.receiverNickName||'无'}}</span>
              </li>
              <li>
                <span>是否情侣</span>
                <span>{{userInfo.isLovers === 0 ? '否':'是'}}</span>
              </li>
            </ul>
          </div>
        </div>
        <p class="title-line">上链内容</p>
        <div class="chain-box">
          <p class="comment-user" v-if="userInfo.forwardList">
            <span v-for="(item,index) in userInfo.forwardList" :key="index">
              <span style="color:#2a5caa">@{{item.originatorNickName}} :</span>
              <pre><code> {{deCodeUnicode(item.content)}}</code></pre>
              <span v-if="index!==userInfo.forwardList.length-1">//</span>
            </span>
          </p>
          <div
            class="comment"
            :class="{'comment-color':userInfo.forwardList&&userInfo.forwardList.length!==0}"
          >
            <p class="raw-txt" v-if="userInfo.content">{{deCodeUnicode(userInfo.content)}}</p>
            <div class="video-box" v-if="userInfo.videos">
              <video :src="userInfo.videos[0]" controls="controls"></video>
            </div>
            <img :src="item" v-for="item in userInfo.images" :key="item">
            <!-- <iframe :src="userInfo.pdfUrl"></iframe> -->
            <a :href="userInfo.pdfUrl" class="linkPDF" target="_blank" v-if="userInfo.pdfUrl">点击查看协议</a>
          </div>
        </div>
      </div>
      <div v-else class="tips">输入宣言 / 协议哈希搜索宣言</div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import { checkRaw } from "../../assets/js/filter.js";
export default {
  data() {
    return {
      searchHash: "",
      form: Object,
      userInfo: {},
      isValid: false
    };
  },
  computed: {
    size() {
      return document.body.clientWidth;
    }
  },
  mounted() {
    const hash = this.$route.query.hash
      ? this.$route.query.hash
      : this.searchHash;
    this.searchHash = hash.trim();
    if (hash) {
      this.searchInfo();
    }
  },
  methods: {
    deCodeUnicode(val) {
      return eval("'" + val + "'");
    },
    searchInfo() {
      if (this.searchHash.trim() === "") return Toast("请输入宣言哈希");
      else {
        Indicator.open("查询中...");
        this.$chain33Rpc
          .queryTransaction(this.searchHash)
          .then(data => {
            if (data.error === null) {
              this.userInfo = checkRaw(data.result);
              console.log(this.userInfo);
              if (
                this.userInfo.forwardList &&
                this.userInfo.forwardList.length > 0
              ) {
                let commentator = this.userInfo.forwardList[0];
                this.userInfo.originatorNickName =
                  commentator.originatorNickName;
                this.userInfo.isLovers = commentator.isLovers;
                this.userInfo.receiverNickName =
                  commentator.receiverNickName || "无";
              }
              if (typeof this.userInfo === "object") {
                this.isValid = true;
                this.form = data.result;
                this.form.hash = this.searchHash;
                this.searchHash = "";
                this.$router.push(`/ganma.html?hash=${this.form.hash}`);
              } else {
                this.searchHash = "";
                this.isValid = false;
                Toast(this.userInfo);
              }
            } else {
              Toast("输入哈希错误");
            }
            Indicator.close();
          })
          .catch(() => {
            Indicator.close();
          });
      }
    },
    success() {
      Toast("复制成功");
    },
    error() {
      Toast("复制失败");
    }
  }
};
</script>

<style lang="scss">
.ganme {
  max-width: 1000px;
  min-height: 100vh;
  margin: 0 auto;
  background: rgba(244, 248, 248, 1);
  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .content {
    padding: 4vw;
    .title-line {
      height: 50px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
      padding-left: 5px;
      margin: 10px 0 0 0;
    }
    .transfer-box {
      margin-bottom: 10px;
    }
    .top-line {
      .icon {
        width: 80px;
        margin-bottom: 10px;
      }
      .search {
        -webkit-appearance: none;
        height: 39px;
        line-height: 39px;
        position: relative;
        display: flex;
        align-items: center;
      }
      .search:focus {
        outline: none;
      }
      div.search {
        margin-top: 3vw;
      }
      img.search {
        z-index: 10;
        position: absolute;
        height: 20px;
        left: 15px;
      }
      input.search {
        width: 100%;
        padding: 0 30px 0 45px;
        border: 1px solid rgba(229, 232, 232, 1);
        background: #fff;
        border-radius: 20px;
        font-size: 14px;
      }
    }
    .form-centent {
      margin-top: 10px;
      ul li {
        position: relative;
        height: 50px;
        line-height: 50px;
        color: #666666;
        font-size: 14px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        background: #fff;
        border: 1px solid rgba(242, 242, 242, 1);
        .college-icon {
          height: 50px;
          float: right;
          display: flex;
          align-items: center;
          img {
            width: 70%;
          }
        }
        .copy {
          position: absolute;
          right: 5vw;
          color: #5361ff;
          cursor: pointer;
        }
        span:nth-of-type(1) {
          display: inline-block;
          min-width: 6em;
        }
      }
      ul li:last-child {
        border-bottom: none;
      }
    }
    .chain-box {
      position: absolute;
      width: 100vw;
      left: 0;
      padding: 5vw 0;
      background: #fff;
      .comment {
        width: 90vw;
        margin: 0 auto;
        padding: 2vw;
        border-radius: 4px;
      }
      .comment-color {
        background: #f2f4f8;
      }
      .comment-user {
        padding: 0 2vw;
      }
      .raw-txt {
        color: #616161;
        font-size: 14px;
        text-indent: 2em;
      }
      .video-box {
        width: 88vw;
        border-radius: 10px;
        video {
          width: 100%;
          height: 50vw;
          box-shadow: 0px 0px 20px 0px rgb(174, 187, 187);
        }
      }
      img {
        width: 88vw;
        border-radius: 10px;
        margin: 2vw 0;
        box-shadow: 0px 0px 10px 0px rgb(174, 187, 187);
      }
      .linkPDF {
        display: block;
        text-align: center;
        text-decoration: none;
        color: #616161 !important;
      }
    }
  }
  pre {
    line-height: 25px;
    font-size: 14px;
    display: inline-block;
    font-family: "微软雅黑";
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
.tips {
  margin-top: 100px;
  text-align: center;
  color: #666666;
}
</style>


